import React, { ReactNode, useContext } from 'react';

import { WindowDimensionsContext } from '@/components/WindowDimensionsContext';
import {
  GRID_CLASSES,
  GRID_COLUMNS,
  UserPermissionsContentWidth,
} from '@/core/users/UserPermissions/UserPermissionsContentWidth';

const STICKY_VIEWPORT_HEIGHT_THRESHOLD_PX = 800;

type Props = {
  children: ReactNode;
  renderNotification?: ReactNode;
}
export function StickyHeader ({ children, renderNotification }: Props) {
  const { height } = useContext(WindowDimensionsContext);

  return (
    <div
      className={`z-10 bg-white ${renderNotification ? '' : 'pt-12'} ${height > STICKY_VIEWPORT_HEIGHT_THRESHOLD_PX ? 'sticky top-0' : ''}`}
      style={{ boxShadow: '0px 4px 11px rgba(0, 0, 0, 0.06)' }}
    >
      <UserPermissionsContentWidth>
        <div
          className={`text-gray-800 ${GRID_CLASSES}`}
          style={{ gridTemplateColumns: GRID_COLUMNS }}
        >
          { renderNotification }
          { children }
        </div>
      </UserPermissionsContentWidth>
    </div>
  );
}
